(() => {
  const end = Date.parse('2026-09-27T00:00:00+02:00');
  const update = () => {
    if (Date.now() < end) return;
    document.querySelectorAll('[data-fulfillment-break]').forEach((notice) => {
      notice.hidden = true;
    });
    document.querySelectorAll('[data-fulfillment-break-property]').forEach((input) => {
      input.disabled = true;
    });
  };
  update();
  window.setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
})();
